import Component from "@glimmer/component"

interface Signature {}

export default class GoogleClassroomAddAttachmentMenuComponent extends Component<Signature> {}
